<template>
  <!-- 编辑配置信息弹窗 -->
  <div id="configSetTem">
    <el-form ref="editDevicePop" v-loading="loadEditPop" class="editDevicePop" :model="editBasicinfo" :rules="editRules" label-position="right" label-width="205px">
      <div v-if="isShowConfigStatu" class="configStatu">
        {{ $t('AllDevices.SetChanged1') }}{{ editBasicinfo.newConfigTime }}{{ $t('AllDevices.SetChanged2') }}
        <span class="configStatuLook" @click="openConfigStatuPop">{{ $t('AllDevices.View') }}</span>
        <i class="el-icon-info" />
      </div>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="deviceSn">
            <el-input v-model="editBasicinfo.deviceSn" :disabled="true" :placeholder="$t('BondOrUpdateDevice.FindSN')" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceName">
            <el-input v-model="editBasicinfo.deviceName" :disabled="true" :placeholder="$t('BondOrUpdateDevice.PleaseEnterAName')" @input="change" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Model')">
            <!-- 电池型号 -->
            <el-cascader v-model="batteryCascader" :options="options2" :placeholder="editBasicinfo.batteryBrand + '/' + editBasicinfo.batteryModel" 
            :show-all-levels="true" style="width: 200px" :disabled="noneConfig" @change="batteryModelChange" />
            <p v-if="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }} </p>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col c520">
          <el-form-item :label="$t('AllDevices.Type')">
            <el-radio-group v-model="editBasicinfo.c520" @input="changeEditC520">
              <el-radio :label="1" v-if="batteryModelObj.batteryAh">C20</el-radio>
              <el-radio :label="3" v-if="batteryModelObj.batteryAhC6">C6</el-radio>
              <el-radio :label="2" v-if="batteryModelObj.batteryAhC5">C5</el-radio>
              <el-radio :label="4" v-if="batteryModelObj.batteryAhC3">C3</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Capacity')" prop="batteryTotalah">
            <!--容量-->
            <el-input v-model="editBasicinfo.batteryTotalah" :placeholder="$t('BondOrUpdateDevice.EnterBatteryCapacity')" type="number" :disabled="noneConfig" @input="change" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('basicinfo.SystemVoltage')" prop="batterySystemVolt">
            <!--系统电压-->
            <el-input v-model="editBasicinfo.batterySystemVolt" :placeholder="$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage')" type="number" :disabled="noneConfig" @input="change" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <!--CAN类型-->
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('CAN')" prop="canFuntion">
            <!-- <template class="ycdd"> -->
            <el-select v-model="editBasicinfo.canFuntion" :placeholder="$t('button.select')" :disabled="noneConfig" @input="change">
              <el-option v-for="item in canOptions" :key="item.code" :label="item.code + ' ' + item.des" :value="item.code" />
            </el-select>
            <!-- </template> -->
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.LevelSensor')">
            <!--液位采集-->
            <el-radio v-model="editBasicinfo.supportWaterlevel" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <el-radio v-model="editBasicinfo.supportWaterlevel" :label="0" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item label="APN">
            <!-- <p>{{ editBasicinfo.gprsApnName }}</p> -->
            <el-select v-model="editBasicinfo.gprsApnName" :disabled="true" @input="change">
              <el-option v-for="item in apnOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.communication')" class="ycdd">
            <!--485通讯-->
            <el-radio v-model="editBasicinfo.communication485" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.communication485" :label="2" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.currentCollection')" class="ycdd">
            <!--通道2电流采集功能-->
            <el-radio v-model="editBasicinfo.currentCollection2" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.currentCollection2" :label="2" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.AuxVolAcquisition')" class="ycdd">
            <!--Aux电压采集功能-->
            <el-radio v-model="editBasicinfo.voltageCollection2" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.voltageCollection2" :label="2" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.RemoteControl')">
            <!--远程断电-->
            <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="0" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
            <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <!-- <el-input v-model="editBasicinfo.locationSample" type="text" />{{ $t('BondOrUpdateDevice.SecondsTimes') }} -->
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('AllDevices.HardwareV')">
            <!--硬件电压等级1：高压版本  其他：非高压版本-->
            <el-radio v-model="editBasicinfo.voltClass" :label="1" :disabled="!$store.state.isAdmin||noneConfig" @change="change">
              {{ $t('AllDevices.HighVVersion') }}</el-radio>
            <el-radio v-model="editBasicinfo.voltClass" :label="2" :disabled="!$store.state.isAdmin||noneConfig" @change="change">
              {{ $t('AllDevices.NonHighVVersion') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.canopenBaudrate')">
            <el-radio v-model="editBasicinfo.canopenBaudrate" :label="1" :disabled="noneConfig" @change="change">125K</el-radio>
            <el-radio v-model="editBasicinfo.canopenBaudrate" :label="2" :disabled="noneConfig" @change="change">250K</el-radio>
            <el-radio v-model="editBasicinfo.canopenBaudrate" :label="3" :disabled="noneConfig" @change="change">500K</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.NodeID')" prop="nodeID">
            <el-input-number v-model="editBasicinfo.nodeID" :step="1" :disabled="noneConfig" @change="change" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.LEDIndicator')">
            <!--面板指示灯-->
            <el-radio v-model="editBasicinfo.ledSetting" :label="1" :disabled="noneConfig" @change="change">
              {{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <el-radio v-model="editBasicinfo.ledSetting" :label="2" :disabled="noneConfig" @change="change">
              {{ $t('BondOrUpdateDevice.No') }}</el-radio>
          </el-form-item>
        </el-col>
        <!-- 设备重置 -->
        <el-col v-if="!$store.state.userInfo.guestFlag&&editBasicinfo.showAll != 1" :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('allDeviceDetail.resetFunction')">
            <el-button class="filter-item" type="primary" :disabled="noneConfig" @click="restoreFactorySet">
              {{ $t('allDeviceDetail.startReset') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('BondOrUpdateDevice.SensorType')">
        <!--电流计类型-->
        <el-radio v-model="editBasicinfo.sensorType" :label="2" :disabled="noneConfig" @change="sensorTypeChange">
          SHUNT</el-radio>
        <el-radio v-model="editBasicinfo.sensorType" :label="1" :disabled="noneConfig" @change="sensorTypeChange">
          HALL</el-radio>
        <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="1" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Forward') }}</el-radio>
        <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="2" :disabled="noneConfig" @change="change">{{ $t('BondOrUpdateDevice.Reverse') }}</el-radio>
        <el-select v-model="editBasicinfo.hallSensorRange" :disabled="noneConfig" style="width:120px;" @input="change">
          <el-option v-for="item in sensorRangeOptions" v-show="!item.disabled" :key="item.key" :label="item.label" :value="item.key" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('BondOrUpdateDevice.Track')" class="ycdd" prop="locationSample">
        <!--运动轨迹-->
        <el-radio v-model="editBasicinfo.motionTrack" :label="1" :disabled="noneConfig" @change="change">
          {{ $t('BondOrUpdateDevice.Off') }}</el-radio>
        <el-radio v-model="editBasicinfo.motionTrack" :label="2" :disabled="noneConfig" @change="change">
          {{ $t('BondOrUpdateDevice.On') }}</el-radio>
        <div v-show="editBasicinfo.motionTrack==2" style="display: inline-block;position:relative;">
          <el-input-number v-model="editBasicinfo.locationSample" size="medium" step-strictly :step="1" type="small" :disabled="noneConfig" style="width: 200px;" @input="change('locationSample')" />
          <p v-if="isShowLocationSampleWarn" class="LocationSampleWarn">{{ $t('BondOrUpdateDevice.enterNumOver').replace('$1',30) }}</p>
          <span>{{ $t('BondOrUpdateDevice.SecondsTimes') }}</span>
        </div>
      </el-form-item>

      <!--采样算法-->

      <el-form-item :label="$t('AllDevices.SampAlgorithm')" class="ycdd">
        <div style="position:relative;">
          <el-radio v-model="editBasicinfo.samplingMode" :label="1" :disabled="noneConfig" @change="changeCYSF($event)">
            {{ $t('AllDevices.DynamicSamp') }}</el-radio>
          <el-input v-show="editBasicinfo.samplingMode==1" v-model.trim="editBasicinfo.voltChangeRate" :disabled="noneConfig" type="number" style="width: 100px;" @blur="bulrInput(editBasicinfo.voltChangeRate,'voltChangeRate')" @input="change" />
          <span v-show="editBasicinfo.samplingMode==1" style="margin-right:30px;">mV</span>
          <el-radio v-model="editBasicinfo.samplingMode" :label="2" :disabled="noneConfig" @change="changeCYSF($event)">
            {{ $t('AllDevices.StaticSampling') }}</el-radio>
          <el-input v-show="editBasicinfo.samplingMode==2" v-model.trim="editBasicinfo.samplingRate" :disabled="noneConfig" type="number" style="width: 100px;" @blur="bulrInput(editBasicinfo.samplingRate,'samplingRate')" @input="change" />
          <span v-show="editBasicinfo.samplingMode==2">{{ $t('dataAndTime.Second') }}</span>
          <p v-if="isShowMustIntWarn" class="mustIntWarn" style="position:absolute;">{{ editBasicinfo.warnMsg }}</p>
        </div>
      </el-form-item>

      <el-form-item :label="$t('AllDevices.GPSFunction')">
        <!--GPS功能-->
        <el-radio v-model="editBasicinfo.gpsFunction" :label="1" :disabled="noneConfig" @change="change">
          {{ $t('AllDevices.FullyTurnOnGPS') }}</el-radio>
        <el-radio v-model="editBasicinfo.gpsFunction" :label="2" :disabled="noneConfig" @change="change">
          {{ $t('AllDevices.TurnOffGPS') }}</el-radio>
        <el-radio v-model="editBasicinfo.gpsFunction" :label="3" :disabled="true" @change="change">
          {{ $t('AllDevices.StartGPS2h') }}</el-radio>
      </el-form-item>

      <el-form-item :label="$t('AllDevices.NetFeatures')">
        <!--网络功能-->
        <el-radio v-model="editBasicinfo.netFunction" :label="1" :disabled="noneConfig" @change="change">
          {{ $t('AllDevices.FullyOpenNet') }}</el-radio>
        <el-radio v-model="editBasicinfo.netFunction" :label="2" :disabled="true" @change="change">
          {{ $t('AllDevices.StartNetOnce') }}</el-radio>
        <el-radio v-model="editBasicinfo.netFunction" :label="3" :disabled="true" @change="change">
          {{ $t('AllDevices.StartNet2h') }}</el-radio>
      </el-form-item>

      <el-form-item style="text-align: end;">
        <el-button @click="closePop">{{ $t('button.Cancel') }}</el-button>
        <el-button :disabled="disabledSubmit||noneConfig" class="filter-item" type="primary" @click="submitEditDeviceModel('editDevicePop')">{{ $t('button.Submit') }}</el-button>
      </el-form-item>


    </el-form>
  </div>
</template>

<script>
import { getLastOne, deviceBattery, addDeviceBindConfig, querySearchSn, getCompanySiteList, getLastYhubConfig, canFunctionList } from '@/api/allDevice'
import { getDateAndHour } from '@/utils/updateTime.js'

export default {
  name: 'DashboardAdmin',
  components: {
  },
  props: {
    selectRow: {
      type: Object,
      default: () => { }
    },
    options2: {
      type: Array,
      default: () => []
    },
    mcuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 编辑配置信息------start
      editDevicePop: false,
      apnOptions: [],
      canOptions: [],
      batteryModelObj: {},
      isShowBatteryModelWarning: false,
      editBasicinfo: {
        c520: 20,
        batteryTotalah: '',
        batteryBrand: '',
        batteryModel: '',
        batterySystemVolt: '',
        canFuntion: '',
        configFrom: '',
        configTime: '',
        configVersion: '',
        extralFuntion: 0,
        motionTrack: '',
        communication485: '',
        currentCollection2: '',
        voltageCollection2: '',
        gprsApnKey: '',
        gprsApnName: '',
        gprsApnUser: '',
        hallDirection: '',
        hallSensorRange: '',
        isSupportPgt: '',
        isSupportRelaycontrol: '',
        isSupportWaterlevel: '',
        ledSetting: '',
        locationSample: 60,
        productionData: '',
        samplingMode: 1,
        voltChangeRate: 300,
        samplingRate: 480,
        gpsFunction: 1,
        netFunction: 1,
        voltClass: 1,
        canopenBaudrate: 2,
        nodeID: 85
      },
      batteryCascader: [],
      isShowHallDetail: false,
      disabledSubmit: true,
      noneConfig: false,
      isShowConfigStatu: false,
      configStatuPop: false,
      nowAndNewConfigData: [],
      loadEditPop: false,
      isShowCellNumPop: false,
      isShowMustIntWarn: false,
      sensorRangeOptions: [
        { key: 1, label: '300A', disabled: false },
        { key: 3, label: '750A', disabled: false },
        { key: 2, label: '800A', disabled: true }
      ],
      canopenBaudrateOption: [
        { key: 1, label: '125K' },
        { key: 2, label: '250K' },
        { key: 3, label: '500K' }
      ],
      lvp: {
        switch: false,
        lv1: '',
        lv2: '',
        lv3: '',
        recover: ''
      },
      isShowLocationSampleWarn: false,
      oldLocationSample: 60

      // 编辑配置信息------end
    }
  },
  computed: {
    editRules() {
      var checkNodeId = (rule, value, callback) => {
        if ((value === '' || !value) && value != 0) {
          callback(new Error(this.$t('lease.Cannotbeblanked2')))
        } else if (value < 1 || value > 127) {
          var str = this.$t('BondOrUpdateDevice.enterNumScope')
          var newStr = str.replace('$1', '1')
          newStr = newStr.replace('$2', '127')
          callback(new Error(newStr))
        } else {
          callback()
        }
      }
      return {
        batteryTotalah: [{ required: true, message: this.$t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: ['blur', 'change'] }], // 容量不能为空
        batterySystemVolt: [{ required: true, message: this.$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: ['blur', 'change'] }],
        nodeID: [{ validator: checkNodeId, trigger: ['blur', 'change'] }]
      }
    },
    // 101:Android、102:IOS、103:Uni-APP（安卓）、104:Xtools、201:VUE前端、105:Uni-APP（IOS）、106:Uni-APP（安卓微信小程序）、
    // 107：蓝牙（安卓App）、108：蓝牙（IOSAPP）、109:Uni-APP（IOS微信小程序）、202:安卓微信小程序-蓝牙、203:IOS微信小程序-蓝牙
    configFromOptions() {
      return [
        { value: 101, label: 'Android' },
        { value: 102, label: 'IOS' },
        { value: 103, label: 'Uni-APP(Android)' },
        { value: 104, label: 'Xtools' },
        { value: 105, label: 'Uni-APP(IOS)' },
        { value: 106, label: this.$t('adminView.UniAnWeChat') },
        { value: 107, label: this.$t('adminView.BleAnApp') },
        { value: 108, label: this.$t('adminView.BleIOSApp') },
        { value: 109, label: this.$t('adminView.UniIOSWeChat') },
        { value: 201, label: 'Admin' },
        { value: 202, label: this.$t('adminView.BleAnWeChat') },
        { value: 203, label: this.$t('adminView.BleIOSWeChat') },
        { value: 204, label: 'DRM' }
      ]
    }
  },
  watch: {
    selectRow: {
      handler(newValue, oldValue) {
        console.log('newValue--selectRow', newValue)
        this.selectRow = newValue
        if (this.selectRow.mcuId) this.yhubEditInt()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    
  },
  created() {
    this._canFunctionList()
  },
  methods: {
    _canFunctionList() {
      canFunctionList().then((res) => {
        this.canOptions = res.resultModel
      })
    },
    yhubEditInt(row) { // 编辑配置弹窗--弹窗显示
      this.loadEditPop = true
      this.$nextTick(() => {
        this.$refs.editDevicePop.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
      })
      this.isShowMustIntWarn = false
      this.isShowOwnCompany = this.disabledSubmit = this.isShowConfigStatu = false
      for (var attr in this.selectRow) {
        if (this.selectRow[attr] || this.selectRow[attr] == 0) this.editBasicinfo[attr] = this.selectRow[attr]
      }
      getLastOne({ mcuId: this.editBasicinfo.mcuId }).then((res) => {
        console.log('getlastone:', res)
        if (res.resultCode == 1001) {
          var extralArr2
          // if (!res.resultModel) {
          if (!res.resultModel || !res.resultModel.jsonData || !JSON.parse(res.resultModel.jsonData).gprs_apn_name) {
            this.loadEditPop = false
            this.$message({
              type: 'error',
              message: this.$t('AllDevices.NoNetworkInfo')// '未找到联网信息，无法绑定，请联系管理员'
            })
            this.noneConfig = true
            this.editBasicinfo.batteryBrand = this.editBasicinfo.batteryModel = ''
            this.batteryCascader = []
          } else {
            this.noneConfig = false
            var jsonData = JSON.parse(res.resultModel.jsonData)
            console.log(jsonData)

            // 低压保护初始化
            this.lvp.switch = jsonData.is_support_lowVol_protection
            this.lvp.recover = (jsonData.recovery_voltage / 100).toFixed(2)
            this.lvp.lv1 = (jsonData.warn_1_voltage / 100).toFixed(2)
            this.lvp.lv2 = (jsonData.warn_2_voltage / 100).toFixed(2)
            this.lvp.lv3 = (jsonData.warn_3_voltage / 100).toFixed(2)

            var newJsonData = {}
            for (var i in jsonData) {
              var oldI = i
              // 由于json中的属性用的是烤串模式命名，需要转化为驼峰法命名
              if (i.indexOf('_') > -1) {
                var arrI = i.split('_')
                arrI.forEach((v, vi) => {
                  if (vi != 0) arrI[vi] = v[0].toUpperCase() + v.slice(1)
                })
                i = arrI.join('')
              }
              newJsonData[i] = jsonData[oldI]
            }
            console.log('newJsonData', newJsonData)
            // this.editBasicinfo = newJsonData
            for (var attr in newJsonData) {
              if (newJsonData[attr] || newJsonData[attr] == 0) this.editBasicinfo[attr] = newJsonData[attr]
            }
            this.editBasicinfo.batteryBrand = res.resultModel.batteryBrand
            this.editBasicinfo.batteryModel = res.resultModel.batteryModel
            this.editBasicinfo.batteryId = newJsonData.sdBattery.battery_id == 0 ? 2 : newJsonData.sdBattery.battery_id
            this.editBasicinfo.supportWaterlevel = newJsonData.isSupportWaterlevel ? 1 : 0
            this.editBasicinfo.supportRelaycontrol = newJsonData.isSupportRelaycontrol ? 1 : 0
            this.editBasicinfo.canopenBaudrate = newJsonData.canopenBaudrate ? newJsonData.canopenBaudrate : 2
            this.editBasicinfo.nodeID = newJsonData.nodeId ? newJsonData.nodeId : 85
            this.isShowHallDetail = newJsonData.sensorType == 1
            if (!newJsonData.extralFuntion) newJsonData.extralFuntion = 0
            extralArr2 = this.decimalToBinary(newJsonData.extralFuntion, 2)
            console.log('getLastOne:editBasicinfo--', this.editBasicinfo)
            this.editBasicinfo.ledSetting = newJsonData.ledSetting == 2 ? 2 : 1
            this.editBasicinfo.hallDirection = newJsonData.hallDirection == 2 ? 2 : 1
            this.editBasicinfo.batteryTotalah = Math.round(newJsonData.batteryTotalAh / 100)

            this.editBasicinfo.motionTrack = extralArr2[1] === 1 ? 2 : 1// 运动轨迹
            this.editBasicinfo.communication485 = extralArr2[3] === 1 ? 2 : 1
            this.editBasicinfo.currentCollection2 = extralArr2[4] === 1 ? 2 : 1
            this.editBasicinfo.voltageCollection2 = extralArr2[5] === 1 ? 2 : 1

            if (newJsonData.samplingRate) this.editBasicinfo.samplingRate = newJsonData.samplingRate / 1000
            this.findPC = this.$t('allDeviceDetail.findPC1') + this.editBasicinfo.deviceSn + this.$t('allDeviceDetail.findPC2')
            this.editBasicinfo.locationSample = (!this.editBasicinfo.locationSample || this.editBasicinfo.locationSample < 30) ? 60 : this.editBasicinfo.locationSample
            if (!newJsonData.samplingMode) this.editBasicinfo.samplingMode = 1
            if (!newJsonData.voltChangeRate && newJsonData.voltChangeRate != 0) this.editBasicinfo.voltChangeRate = 300
            if (!newJsonData.samplingRate && newJsonData.samplingRate != 0) this.editBasicinfo.samplingRate = 480
            if (!newJsonData.gpsFunction) this.editBasicinfo.gpsFunction = 1
            if (!newJsonData.netFunction) this.editBasicinfo.netFunction = 1
            if (newJsonData.voltClass != 1) this.editBasicinfo.voltClass = 2
            if (this.editBasicinfo.locationSample == 4294967295) this.editBasicinfo.locationSample = 60
            this.oldLocationSample = this.editBasicinfo.locationSample
            this.editBasicinfo.batterySystemVolt = newJsonData.batterySystemVolt > 1000 ? Math.round(newJsonData.batterySystemVolt / 100) : newJsonData.batterySystemVolt
            this.selectRow.voltChangeRate = this.editBasicinfo.voltChangeRate
            this.selectRow.samplingRate = this.editBasicinfo.samplingRate

            deviceBattery({ id: this.editBasicinfo.batteryId }).then(response => {
            console.log('电池信息：', response)
              if (!response.resultModel) return
              const bty = response.resultModel;
              this.batteryModelObj = bty

              // if (!bty.batteryAhC5) { this.disabledC5 = true } else { this.disabledC5 = false }
              this.editBasicinfo.batteryBrand = bty.batteryBrand
              this.editBasicinfo.batteryModel = bty.batteryModel
            })
            getLastYhubConfig({ mcuId: this.editBasicinfo.mcuId }).then((res) => {
              console.log('getLastYhubConfig:', res)
              this.isShowConfigStatu = this.loadEditPop = false
              if (res.resultCode == 1001) {
                if (res.resultModel) {
                  var c520 = res.resultModel.nominalCapacity
                  this.$set(this.editBasicinfo, 'c520', c520)
                  var blueTooth = [107, 108, 202, 203]// 来源于蓝牙
                  if (this.editBasicinfo.configTime != parseInt(res.resultModel.configTime / 1000) && (res.resultModel.status == 1 || res.resultModel.status == 2) && blueTooth.indexOf(res.resultModel.configFrom) == -1) {
                    this.editBasicinfo.newConfigTime = getDateAndHour(res.resultModel.configTime, 'noSecond')
                    this.isShowConfigStatu = true
                    var newConfig = res.resultModel
                    newConfig.batteryId == 0 ? 2 : newConfig.batteryId
                    console.log('this.editBasicinfo', this.editBasicinfo)
                    if (!this.editBasicinfo.extralFuntion) this.editBasicinfo.extralFuntion = 0
                    if (!newConfig.extralFuntion) newConfig.extralFuntion = 0
                    var extralArr2 = this.decimalToBinary(this.editBasicinfo.extralFuntion, 2)
                    var extralArrconfig = this.decimalToBinary(newConfig.extralFuntion, 2)
                    this.editBasicinfo.hallDirectionT = this.editBasicinfo.hallDirection == 1 ? this.$t('BondOrUpdateDevice.Forward') : this.$t('BondOrUpdateDevice.Reverse')
                    newConfig.hallDirectionT = newConfig.hallDirection == 2 ? this.$t('BondOrUpdateDevice.Reverse') : this.$t('BondOrUpdateDevice.Forward')
                    var editGPS
                    switch (this.editBasicinfo.gpsFunction) {
                      case 1: editGPS = this.$t('AllDevices.FullyTurnOnGPS'); break
                      case 2: editGPS = this.$t('AllDevices.TurnOffGPS'); break
                      case 3: editGPS = this.$t('AllDevices.StartGPS2h'); break
                    }
                    var newConfigGPS
                    switch (newConfig.gpsFunction) {
                      case 1: newConfigGPS = this.$t('AllDevices.FullyTurnOnGPS'); break
                      case 2: newConfigGPS = this.$t('AllDevices.TurnOffGPS'); break
                      case 3: newConfigGPS = this.$t('AllDevices.StartGPS2h'); break
                    }
                    var editNet
                    switch (this.editBasicinfo.netFunction) {
                      case 1: editNet = this.$t('AllDevices.FullyOpenNet'); break
                      case 2: editNet = this.$t('AllDevices.StartNetOnce'); break
                      case 3: editNet = this.$t('AllDevices.StartNet2h'); break
                    }
                    var newConfigNet
                    switch (newConfig.netFunction) {
                      case 1: newConfigNet = this.$t('AllDevices.FullyOpenNet'); break
                      case 2: newConfigNet = this.$t('AllDevices.StartNetOnce'); break
                      case 3: newConfigNet = this.$t('AllDevices.StartNet2h'); break
                    }
                    var editCan, newConfigCan
                    this.canOptions.forEach(v => {
                      if (this.editBasicinfo.canFuntion == v.code) editCan = v.des
                      if (newConfig.canFuntion == v.code) newConfigCan = v.des
                    })
                    var editTime, newConfigTime
                    if (this.editBasicinfo.configTime) editTime = getDateAndHour(this.editBasicinfo.configTime * 1000)
                    if (newConfig.configTime) newConfigTime = getDateAndHour(newConfig.configTime)
                    var editConfigFrom, newConfigFrom
                    this.configFromOptions.forEach(v => {
                      if (this.editBasicinfo.configFrom == v.value) editConfigFrom = v.label
                      if (newConfig.configFrom == v.value) newConfigFrom = v.label
                    })
                    var editSensorRange, newSensorRange
                    this.sensorRangeOptions.forEach(v => {
                      if (this.editBasicinfo.hallSensorRange == v.key) editSensorRange = v.label
                      if (newConfig.hallSensorRange == v.key) newSensorRange = v.label
                    })
                    var editCanopenBaudrate; var newConfigCanopenBaudrate = '--'
                    this.canopenBaudrateOption.forEach(v => {
                      if (this.editBasicinfo.canopenBaudrate == v.key) editCanopenBaudrate = v.label
                      if (newConfig.canopenBaudrate == v.key) newConfigCanopenBaudrate = v.label
                    })
                    this.nowAndNewConfigData = []
                    this.nowAndNewConfigData.push(
                      { name: this.$t('BondOrUpdateDevice.Capacity'), value1: this.editBasicinfo.batteryTotalah, value2: Math.round(newConfig.batteryTotalah / 100) },
                      { name: this.$t('BondOrUpdateDevice.Model'), value1: this.editBasicinfo.batteryBrand + '/' + this.editBasicinfo.batteryModel, value2: '/' },
                      { name: this.$t('basicinfo.SystemVoltage'), value1: this.editBasicinfo.batterySystemVolt, value2: newConfig.batterySystemVolt },
                      { name: this.$t('BondOrUpdateDevice.LevelSensor'), value1: this.editBasicinfo.supportWaterlevel == 1 ? this.$t('BondOrUpdateDevice.Yes') : this.$t('BondOrUpdateDevice.No'), value2: newConfig.supportWaterlevel == 1 ? this.$t('BondOrUpdateDevice.Yes') : this.$t('BondOrUpdateDevice.No') },
                      { name: this.$t('BondOrUpdateDevice.LEDIndicator'), value1: this.editBasicinfo.ledSetting == 2 ? this.$t('BondOrUpdateDevice.No') : this.$t('BondOrUpdateDevice.Yes'), value2: newConfig.ledSetting == 2 ? this.$t('BondOrUpdateDevice.No') : this.$t('BondOrUpdateDevice.Yes') },
                      { name: this.$t('BondOrUpdateDevice.communication'), value1: this.editBasicinfo.communication485 == 1 ? this.$t('BondOrUpdateDevice.Off') : this.$t('BondOrUpdateDevice.On'), value2: extralArrconfig[3] == 1 ? this.$t('BondOrUpdateDevice.On') : this.$t('BondOrUpdateDevice.Off') },
                      { name: this.$t('BondOrUpdateDevice.currentCollection'), value1: this.editBasicinfo.currentCollection2 == 1 ? this.$t('BondOrUpdateDevice.Off') : this.$t('BondOrUpdateDevice.On'), value2: extralArrconfig[4] == 1 ? this.$t('BondOrUpdateDevice.On') : this.$t('BondOrUpdateDevice.Off') },
                      { name: this.$t('BondOrUpdateDevice.AuxVolAcquisition'), value1: this.editBasicinfo.voltageCollection2 == 1 ? this.$t('BondOrUpdateDevice.Off') : this.$t('BondOrUpdateDevice.On'), value2: extralArrconfig[5] == 1 ? this.$t('BondOrUpdateDevice.On') : this.$t('BondOrUpdateDevice.Off') },
                      { name: this.$t('BondOrUpdateDevice.RemoteControl'), value1: this.editBasicinfo.supportRelaycontrol == 1 ? this.$t('BondOrUpdateDevice.Yes') : this.$t('BondOrUpdateDevice.No'), value2: newConfig.supportRelaycontrol == 1 ? this.$t('BondOrUpdateDevice.Yes') : this.$t('BondOrUpdateDevice.No') },
                      { name: 'APN', value1: this.editBasicinfo.gprsApnName, value2: newConfig.gprsApnName },
                      { name: this.$t('BondOrUpdateDevice.SensorType'), value1: this.editBasicinfo.sensorType == 2 ? 'SHUNT [' + editSensorRange + ' ]' : 'HALL [ ' + this.editBasicinfo.hallDirectionT + ' ] [ ' + editSensorRange + ' ]', value2: newConfig.sensorType == 2 ? 'SHUNT [' + newSensorRange + ' ]' : 'HALL [ ' + newConfig.hallDirectionT + ' ] [ ' + newSensorRange + ' ]' },
                      { name: this.$t('BondOrUpdateDevice.Track'), value1: extralArr2[1] == 1 ? this.$t('BondOrUpdateDevice.On') + ' [ ' + this.editBasicinfo.locationSample + ' ]' + this.$t('BondOrUpdateDevice.SecondsTimes') : this.$t('BondOrUpdateDevice.Off'), value2: extralArrconfig[1] == 1 ? this.$t('BondOrUpdateDevice.On') + ' [ ' + newConfig.locationSample + ' ]' + this.$t('BondOrUpdateDevice.SecondsTimes') : this.$t('BondOrUpdateDevice.Off') },
                      { name: this.$t('AllDevices.HardwareV'), value1: this.editBasicinfo.voltClass == 1 ? this.$t('AllDevices.HighVVersion') : this.$t('AllDevices.NonHighVVersion'), value2: newConfig.voltClass == 1 ? this.$t('AllDevices.HighVVersion') : this.$t('AllDevices.NonHighVVersion') },
                      { name: this.$t('AllDevices.SampAlgorithm'), value1: this.editBasicinfo.samplingMode == 1 ? this.$t('AllDevices.DynamicSamp') + ' [ ' + this.editBasicinfo.voltChangeRate + ' mV]' : this.$t('AllDevices.StaticSampling') + ' [ ' + this.editBasicinfo.samplingRate + ' ' + this.$t('dataAndTime.Second') + ' ]', value2: newConfig.samplingMode == 1 ? this.$t('AllDevices.DynamicSamp') + ' [ ' + newConfig.voltChangeRate + ' mV]' : this.$t('AllDevices.StaticSampling') + ' [ ' + (newConfig.samplingRate ? newConfig.samplingRate / 1000 : '') + ' ' + this.$t('dataAndTime.Second') + ' ]' },
                      { name: this.$t('AllDevices.GPSFunction'), value1: editGPS, value2: newConfigGPS },
                      { name: this.$t('AllDevices.NetFeatures'), value1: editNet, value2: newConfigNet },
                      { name: this.$t('BondOrUpdateDevice.canopenBaudrate'), value1: editCanopenBaudrate, value2: newConfigCanopenBaudrate },
                      { name: this.$t('BondOrUpdateDevice.NodeID'), value1: this.editBasicinfo.nodeID, value2: newConfig.nodeID || '--' },
                      { name: 'CAN', value1: editCan, value2: newConfigCan },

                      
                      { name: this.$t('adminView.UpdateBy'), value1: '--', value2: newConfig.updateBy },
                      { name: this.$t('adminView.UpdateAt'), value1: editTime, value2: newConfigTime },
                      { name: this.$t('adminView.OperationSource'), value1: editConfigFrom, value2: newConfigFrom },
                    )
                    if (this.editBasicinfo.batteryId == newConfig.batteryId) {
                      this.nowAndNewConfigData[1].value2 = this.editBasicinfo.batteryBrand + '/' + this.editBasicinfo.batteryModel
                    } else {
                      deviceBattery({ id: newConfig.batteryId }).then(response => {
                        this.nowAndNewConfigData[1].value2 = response.resultModel.batteryBrand + '/' + response.resultModel.batteryModel
                      })
                    }
                  } else if (blueTooth.indexOf(res.resultModel.configFrom) > -1 && (parseInt(res.resultModel.configTime / 1000) >= this.editBasicinfo.configTime)) {
                    for (var attr in res.resultModel) {
                      if (res.resultModel[attr] || res.resultModel[attr] == 0) this.editBasicinfo[attr] = res.resultModel[attr]
                    }
                    this.editBasicinfo.batteryId = res.resultModel.batteryId == 0 ? 2 : res.resultModel.batteryId

                    this.isShowHallDetail = res.resultModel.sensorType == 1
                    if (!res.resultModel.extralFuntion) res.resultModel.extralFuntion = 0
                    extralArr2 = this.decimalToBinary(res.resultModel.extralFuntion, 2)
                    // console.log('extral2--', extralArr2)
                    if (res.resultModel.ledSetting == 2) {
                      this.editBasicinfo.ledSetting = 2
                    } else {
                      this.editBasicinfo.ledSetting = 1
                    }
                    if (res.resultModel.hallDirection == 2) {
                      this.editBasicinfo.hallDirection = 2
                    } else {
                      this.editBasicinfo.hallDirection = 1
                    }
                    this.editBasicinfo.batteryTotalah = Math.round(res.resultModel.batteryTotalah / 100)

                    this.editBasicinfo.motionTrack = extralArr2[1] === 1 ? 2 : 1// 运动轨迹
                    this.editBasicinfo.communication485 = extralArr2[3] === 1 ? 2 : 1
                    this.editBasicinfo.currentCollection2 = extralArr2[4] === 1 ? 2 : 1
                    this.editBasicinfo.voltageCollection2 = extralArr2[5] === 1 ? 2 : 1
                    if (res.resultModel.samplingRate) this.editBasicinfo.samplingRate = res.resultModel.samplingRate / 1000
                    this.findPC = this.$t('allDeviceDetail.findPC1') + this.editBasicinfo.deviceSn + this.$t('allDeviceDetail.findPC2')
                    this.editBasicinfo.locationSample = (!this.editBasicinfo.locationSample || this.editBasicinfo.locationSample < 30) ? 60 : this.editBasicinfo.locationSample
                    if (!res.resultModel.samplingMode) this.editBasicinfo.samplingMode = 1
                    if (!res.resultModel.voltChangeRate && res.resultModel.voltChangeRate != 0) this.editBasicinfo.voltChangeRate = 300
                    if (!res.resultModel.samplingRate && res.resultModel.samplingRate != 0) this.editBasicinfo.samplingRate = 480
                    if (!res.resultModel.gpsFunction) this.editBasicinfo.gpsFunction = 1
                    if (!res.resultModel.netFunction) this.editBasicinfo.netFunction = 1
                    if (res.resultModel.voltClass != 1) this.editBasicinfo.voltClass = 2
                    if (this.editBasicinfo.locationSample == 4294967295) {
                      this.editBasicinfo.locationSample = 60
                    }
                    this.oldLocationSample = this.editBasicinfo.locationSample
                    this.editBasicinfo.batterySystemVolt = res.resultModel.batterySystemVolt
                    this.selectRow.voltChangeRate = this.editBasicinfo.voltChangeRate
                    this.selectRow.samplingRate = this.editBasicinfo.samplingRate
                  }
                }
              }
            })
            this.sensorTypeChange()
            this.batteryCascader = ['', { 
              id: this.editBasicinfo.batteryId, 
              batteryBrand: this.editBasicinfo.batteryBrand, 
              batteryModel: this.editBasicinfo.batteryModel 
              }
            ]
          }
        }
      })
    },
    change(e) {
      this.$forceUpdate()
      if (e == 'locationSample') {
        this.isShowLocationSampleWarn = !!((!this.editBasicinfo.locationSample || this.editBasicinfo.locationSample < 30))
      }
    },
    changeCYSF() {
      this.$forceUpdate()
      this.isShowMustIntWarn = false
      this.bulrInput()
    },
    bulrInput(val, attr) { // 电压采样变化率/采样周期--失焦
      var vRate = this.editBasicinfo.voltChangeRate
      var sRate = this.editBasicinfo.samplingRate
      this.isShowMustIntWarn = false
      if (this.editBasicinfo.samplingMode == 1) {
        if (vRate.length == 0) {
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.VSampChange') + ' ' + this.$t('lease.Cannotbeblanked2')
        } else if (vRate < 100 || vRate > 1000) { // 取值范围只能是100-1000
          this.isShowMustIntWarn = true
          var msg = this.$t('AllDevices.mustBetween').replace('$1', this.$t('AllDevices.VSampChange'))
          msg = msg.replace('$2', '100-1000')
          this.editBasicinfo.warnMsg = msg
        } else if (!/^[+]{0,1}(\d+)$/.test(vRate)) { // 必须为整数
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.VSampChange') + ' ' + this.$t('AllDevices.mustInt')
        }
      } else if (this.editBasicinfo.samplingMode == 2) {
        if (sRate.length == 0) {
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.sampPeriod') + ' ' + this.$t('lease.Cannotbeblanked2')
        } else if (sRate < 6 || sRate > 600) {
          this.isShowMustIntWarn = true
          var msg1 = this.$t('AllDevices.mustBetween').replace('$1', this.$t('AllDevices.sampPeriod'))
          msg1 = msg1.replace('$2', '6-600')
          this.editBasicinfo.warnMsg = msg1
        } else if (!/^[0-9][0-9]*(\.[0-9]{1,3})?$/.test(sRate)) { // 只能为整数或最多三位小数
          this.isShowMustIntWarn = true
          this.editBasicinfo.warnMsg = this.$t('AllDevices.sampPeriod') + ' ' + this.$t('AllDevices.intOrThreeDecimal')
        }
      }
    },
    sensorTypeChange(e) { // 绑定设备弹窗--电流计类型选中
      this.$forceUpdate()
      // 绑定设备弹窗--电流计类型选中
      switch (this.editBasicinfo.sensorType) { // 1:HALL 300/800 2:SHUNT 300/750
        case '1': {
          this.isShowHallDetail = true
          this.sensorRangeOptions[1].disabled = true
          this.sensorRangeOptions[2].disabled = false
          // 为hall时，取值不能为750，所以默认为300
          if (this.editBasicinfo.hallSensorRange == 3) this.editBasicinfo.hallSensorRange = 1
          break
        }
        case 1: {
          this.isShowHallDetail = true
          this.sensorRangeOptions[1].disabled = true
          this.sensorRangeOptions[2].disabled = false
          if (this.editBasicinfo.hallSensorRange == 3) this.editBasicinfo.hallSensorRange = 1
          break
        }
        default: {
          this.isShowHallDetail = false
          this.sensorRangeOptions[1].disabled = false
          this.sensorRangeOptions[2].disabled = true
          if (this.editBasicinfo.hallSensorRange == 2) this.editBasicinfo.hallSensorRange = 1
          break
        }
      }
    },
    batteryModelChange(value) { // 绑定设备弹窗--电池型号选中
      console.log('电池型号选择：', value)
      if (!value) value = this.batteryCascader
      
      const bty = value[1];
      this.batteryModelObj = bty
      this.editBasicinfo.c520 = 1;
      this.editBasicinfo.batteryTotalah = bty.batteryAh;
      this.editBasicinfo.batteryId = bty.id
      this.editBasicinfo.batteryBrand = bty.batteryBrand
      this.editBasicinfo.batteryModel = bty.batteryModel
      this.editBasicinfo.batterySystemVolt = bty.batteryVoltage || 24
      this.isShowBatteryModelWarning = false
    },
    changeEditC520(val) { // 改变c5/c20
      console.log(val)
      let ah = this.batteryModelObj.batteryAh;
      if (val == 2) ah = this.batteryModelObj.batteryAhC5
      if (val == 3) ah = this.batteryModelObj.batteryAhC6
      if (val == 4) ah = this.batteryModelObj.batteryAhC3
      this.editBasicinfo.batteryTotalah = ah || this.batteryModelObj.batteryAh
      
    },
    restoreFactorySet() { // 恢复出厂设置弹窗--打开
      this.$emit('openRestorePop')
    },
    openConfigStatuPop() { // 当前配置和待更改配置弹窗--打开
      console.log(this.nowAndNewConfigData)
      this.$emit('openConfigStatuPop', this.nowAndNewConfigData)
    },
    closePop() { // 编辑配置设备信息弹窗--取消
      this.showBatteryModel = false
      for (var attr in this.editBasicinfo) this.editBasicinfo[attr] = ''
      this.editDevicePop = false
      this.$nextTick(() => {
        this.$refs.editDevicePop.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
      })
      this.$emit('closePopClick')
    },
    submitEditDeviceModel(formName) { // 编辑配置设备信息弹窗--提交
      if (this.editBasicinfo.nodeID < 1 || this.editBasicinfo.nodeID > 127) return
      this.$refs[formName].validate((valid) => {
        if (valid && !this.isShowMustIntWarn) {
          var params = JSON.parse(JSON.stringify(this.editBasicinfo))
          var attrArr = ['batteryId', 'samplingMode', 'voltChangeRate', 'samplingRate', 'gpsFunction', 'netFunction', 'voltClass', 'batterySystemVolt', 'batteryTotalah', 'canFuntion', 'configFrom', 'configVersion', 'extralFuntion', 'gprsApnName', 'hallDirection', 'hallSensorRange', 'ledSetting', 'locationSample', 'sensorType', 'supportRelaycontrol', 'supportWaterlevel', 'mcuId', 'canopenBaudrate', 'nodeID']
          for (var attr in params) {
            if (attrArr.indexOf(attr) == -1) {
              delete params[attr] // 去掉无用的参数
            }
          }
          if (!this.editBasicinfo.extralFuntion) this.editBasicinfo.extralFuntion = 0
          var extralArr = this.decimalToBinary(this.editBasicinfo.extralFuntion, 2)
          // motionTrack=2是打开，extralArr[1]=1
          extralArr[1] = this.editBasicinfo.motionTrack == 2 ? 1 : 0
          extralArr[3] = this.editBasicinfo.communication485 == 2 ? 1 : 0
          extralArr[4] = this.editBasicinfo.currentCollection2 == 2 ? 1 : 0
          extralArr[5] = this.editBasicinfo.voltageCollection2 == 2 ? 1 : 0
          params.extral_funtion = params.extralFuntion = Number(this.binaryToDecimal(extralArr))
          params.configFrom = 201
          params.configVersion = this.editBasicinfo.configVersion ? this.editBasicinfo.configVersion + 1 : 1
          // console.log('params---------------', params)
          params.samplingRate = params.samplingRate * 1000
          params.batteryTotalah = params.batteryTotalah * 100
          params.nominalCapacity = this.editBasicinfo.c520
          if (this.editBasicinfo.samplingMode == 1) { params.samplingRate = this.selectRow.samplingRate * 1000 } else { params.voltChangeRate = this.selectRow.voltChangeRate }
          if (params.batteryId == 0) params.batteryId = 2
          if (!params.batteryId) {
            this.isShowBatteryModelWarning = true
            
          } else {
            // 低压保护数据
            params.supportLowvolProtection = this.lvp.switch ? 1 : 0
            params.recoveryVoltage = this.lvp.recover * 100
            params.warn1voltage = this.lvp.lv1 * 100
            params.warn2voltage = this.lvp.lv2 * 100
            params.warn3voltage = this.lvp.lv3 * 100

            if (this.editBasicinfo.motionTrack == 1) params.locationSample = this.oldLocationSample
            if (this.editBasicinfo.motionTrack == 2 && this.isShowLocationSampleWarn) return
            console.log('提交的参数：', params)
            addDeviceBindConfig(params).then((response) => {
              if (response.resultCode === 1001) {
                this.closePop()
                this.$notify({
                  title: '',
                  message: this.$t('warningSet.submitted'),
                  type: 'success',
                  duration: 2000
                })
              } else {
                this.$notify({
                  title: '',
                  message: response.resultMessage,
                  type: 'warning',
                  duration: 2000
                })
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    decimalToBinary(num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
        // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    binaryToDecimal(arr) { // 二进制转十进制
      var a = []
      var allZero = arr.every(m => { return m == 0 })
      if (allZero) {
        c = 0
      } else {
        arr.forEach((v, i) => {
          var end = arr.slice(i)
          // 如果v=1,并且v后面没有1了，则a等于v及其之前的数。如：arr=[0,1,1,1,1,0,0,0] => a=[0,1,1,1,1]
          if (v == 1 && end.indexOf(1) > -1) a = arr.slice(0, i + 1)
        })
        var b = a.reverse().join('')
        var c = parseInt(b, 2).toString(10)
      }
      return c
    },
    getCity() { // 获取已有的地址1
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    querySearchCity(queryString, cb) { // 获取已有的地址2
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    existsOrZero(val) { // 存在或为零则为ture
      if (val && typeof (val) === 'string') val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (val === '') {
        return false
      } else if (val || val == 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.in_item {
  margin-right: 40px;
  margin-bottom: 10px;
}
p {
  margin: 0;
}

.headContent {
  position: absolute;
  // z-index: 999;
  margin: 0 60px -60px 16px;
  float: left;
  top: 20px;
  width: 100%;
}
.headContent img {
  width: 80px;
}
.headContentQuestion {
  font-size: 22px;
  color: #a5a5a5;
  display: inline-block;
  vertical-align: top;
  margin: 7px 0 0 -5px;
  cursor: pointer;
}
.questionPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  margin: -8px 0 0 -240px;
  width: 30%;
}
.allDevice {
  width: 80px;
  height: 54px;
  line-height: 54px;
  vertical-align: top;
  background: white;
  font-size: 36px;
  color: #1990fc;
  text-align: center;
  border: 1px solid #e6e9edc9;
  border-radius: 3px;
  margin-right: -5px;
}

.formRow {
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  // margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  left: calc(50% + 15px);
  top: 0px;
}
.chargeDisBox {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
  padding: 15px;
  .attr {
    margin-bottom: 0px !important;
  }
}
.chargeDisWarp {
  display: inline !important;
  .btnWarp {
    text-align: right;
    margin-top: 20px;
    position: relative;
    z-index: 9999;
  }
}
.configStatu {
  padding: 5px 10px;
  background: #80808029;
  margin-bottom: 20px;
  display: inline-block;
}
.configStatuLook,
.el-icon-info {
  color: #1990fc;
  cursor: pointer;
}
.LocationSampleWarn{
  position: absolute;
  top: 27px;
  color: red;
  font-size: 12px;
}
</style>
